// src/utils/mapLayers.js
import TileLayer from 'ol/layer/Tile'
import WMTS from 'ol/source/WMTS'
import { get as getProjection } from 'ol/proj'
import { getWidth, getTopLeft } from 'ol/extent'
import WMTSTileGrid from 'ol/tilegrid/WMTS'
import CONFIG from '../config/GIS_Config'

// 1. 投影配置
const projection = getProjection(CONFIG.PROJECTION)
const projectionExtent = projection.getExtent()

/**
 * 创建WMTS瓦片图层
 * @returns {TileLayer} WMTS瓦片图层实例
 */
export function createLayerEm_topology_node_pipeline() {
  // 3. 瓦片网格配置
  const tileGrid = new WMTSTileGrid({
    origin: getTopLeft(projectionExtent),
    resolutions: CONFIG.TILE_MATRIX_SET.RESOLUTIONS,
    matrixIds: CONFIG.TILE_MATRIX_SET.MATRIX_IDS,
    tileSize: CONFIG.TILE_MATRIX_SET.TILE_SIZE,
    extent: projectionExtent,
  })

  const layerConfig = CONFIG.LAYER_PARAMS.SPECIFIC.EM_TOPOLOGY

  // 4. WMTS源配置
  const wmtsSource = new WMTS({
    url: CONFIG.SERVICE_PATHS.WMTS_BASE(CONFIG.WORKSPACE),
    layer: layerConfig.name,
    matrixSet: CONFIG.LAYER_PARAMS.WMTS_BASE.matrixSet,
    format: 'image/png',
    style: '',
    projection: CONFIG.LAYER_PARAMS.WMTS_BASE.projection,
    tileGrid: tileGrid,
    tileUrlFunction: tileCoord => {
      layerConfig.tileUrlTemplate(CONFIG.TILE_MATRIX_SET.ID, ...tileCoord)
    },
  })

  // 5. 创建瓦片图层
  return new TileLayer({ source: wmtsSource })
}
